export { default as EpicGamesIcon } from '~icons/simple-icons/epicgames';
